import { useForm, zodResolver } from '@mantine/form';
import { useState } from 'react';

import { TSDListItem, TSDSimulatorStatusUpdatePayload, TSDSimulatorStatusUpdatePayloadSchema } from '@e-origin/contracts';

interface UseSimulatorFormInitializerProps {
  tsd: TSDListItem;
  onHide(): void;
  onSubmit(payload?: Record<string, unknown>): Promise<void> | void;
}

const toIsoString = (date?: Date): string | undefined => {
  return date ? date.toISOString() : undefined;
};

const appendIfFilled = (payload: Record<string, unknown>, key: string, value?: string | null) => {
  const trimmedValue = value?.trim();

  if (trimmedValue) {
    payload[key] = trimmedValue;
  }
};

export const useSimulateTsdStatusUpdateFormInitializer = ({ onHide, onSubmit }: UseSimulatorFormInitializerProps) => {
  const [submitting, setSubmitting] = useState(false);

  const form = useForm<TSDSimulatorStatusUpdatePayload>({
    mode: 'controlled',
    initialValues: {
      status: '08',
      statusReason: undefined,
      notificationDate: new Date(),
      timerForTemporaryStorage: undefined,
      remarks: '',
    },
    validate: zodResolver(TSDSimulatorStatusUpdatePayloadSchema),
    validateInputOnBlur: true,
  });

  const onSubmitForm = async (values: TSDSimulatorStatusUpdatePayload) => {
    try {
      setSubmitting(true);

      const payload: Record<string, unknown> = {
        status: values.status,
        notificationDate: toIsoString(values.notificationDate),
        timerForTemporaryStorage: toIsoString(values.timerForTemporaryStorage),
      };

      appendIfFilled(payload, 'statusReason', values.statusReason);
      appendIfFilled(payload, 'remarks', values.remarks);

      await onSubmit(payload);
    } catch {
      // toast handled by mutation
    } finally {
      setSubmitting(false);
      onHide();
    }
  };

  return {
    form,
    onSubmit: onSubmitForm,
    submitting,
  };
};
